export interface ICalendarGroup {
  id: number;
  name: string;
  description: string;
  order?: any;
  start_date: string;
  end_date: string;
  nbr_places: number;
  restrictions_gender: string[];
  restriction_age_min: number;
  restriction_age_max: number;
  nbr_places_remaining: number
  waiting_list?: boolean
  validate_age_on: string;
  activity: Activity;
  programmation_id?: number;
  schedules: Schedule[];
  location?: {
    id: number,
    type: string,
    full_name: string,
    name: string
  },
}

interface Schedule {
  type_day: string;
  start_time: string;
  end_time: string;
}

interface Activity {
  id: number;
  name: string;
  description: string;
  reservation_required: boolean;
  lowest_price: string;
  registration_template: string;
  image_icon?: {
    path: string
  }
}
export interface IActivity {
  id: string,
  name: string,
  shortDescription: string,
  discountTotal: number,
  discountExpiredAt: string,
  categories: IFilter[],
  mediaPath: string
}

export interface IFilter {
  id: string,
  name: string
}

export interface IFilterMode {
  mode: FilterModes
}

export enum FilterModes {
  in,
  out,
}
